import React, { useState } from 'react';
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonText,
    useIonToast
} from '@ionic/react';
import { useAuth } from '../contexts/AuthContext';

export const MagicLinkForm: React.FC = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [sent, setSent] = useState(false);
    const { loginWithMagicLink, isLoading } = useAuth();
    const [present] = useIonToast();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        try {
            await loginWithMagicLink(email);
            setSent(true);
            present({
                message: 'Magic link sent to your email',
                duration: 3000,
                position: 'bottom',
                color: 'success'
            });
        } catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to send magic link';
            setError(message);
            present({
                message,
                duration: 3000,
                position: 'bottom',
                color: 'danger'
            });
        }
    };

    if (sent) {
        return (
            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>Check Your Email</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <p>We've sent a magic link to {email}. Click the link in the email to sign in.</p>
                    <div className="ion-padding-top">
                        <IonButton
                            expand="block"
                            onClick={() => {
                                setEmail('');
                                setSent(false);
                            }}
                        >
                            Send New Link
                        </IonButton>
                    </div>
                </IonCardContent>
            </IonCard>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <IonCard>
                <IonCardHeader>
                    <IonCardTitle>Sign in with Email</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <IonList>
                        <IonItem>
                            <IonLabel position="floating">Email</IonLabel>
                            <IonInput
                                type="email"
                                value={email}
                                onIonChange={e => setEmail(e.detail.value || '')}
                                required
                            />
                        </IonItem>
                    </IonList>

                    {error && (
                        <IonText color="danger">
                            <p className="ion-padding-start">{error}</p>
                        </IonText>
                    )}

                    <div className="ion-padding-top">
                        <IonButton
                            expand="block"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Sending...' : 'Send Magic Link'}
                        </IonButton>
                    </div>
                </IonCardContent>
            </IonCard>
        </form>
    );
}; 